import moment from "moment";
import CashInvoices from "../components/his/billing/CashInvoices";
import CreditNotesCompanyInvoice from "../components/his/billing/CreditNotesCompanyInvoice";
import CreditNotesInvoice from "../components/his/billing/CreditNotesInvoice";
import InsuranceInvoice from "../components/his/billing/InsuranceInvoice";
import CorporateInvoice from "../components/his/billing/CorporateInvoice";
import GovernmentInvoice from "../components/his/billing/GovernmentInvoice";
import CreditNotesCorporateInvoice from "../components/his/billing/CreditNotesCorporateInvoice";
import CreditNotesGovernmentInvoice from "../components/his/billing/CreditNotesGovernmentInvoice";
import InsuranceClaimInvoiceList from "../components/his/billing/insuranceClaimInvoice/InsuranceClaimInvoiceList";
import InsuranceClaimCreditInvoice from "../components/his/billing/insuranceClaimInvoice/InsuranceClaimCreditInvoice";
import CustomChip from "../shared/CustomChip";
import { formatDate, formatDateTime } from "../utils/FormateDateTime";
import {
  getColor,
  sequenceTableTemplate,
  statusTemplate,
} from "../utils/squenceTableNo";
import {
  FaMoneyBillWave,
  FaFileInvoiceDollar,
  FaPercentage,
  FaClipboardList,
  FaPlus,
} from "react-icons/fa";
import DepositList from "../pages/HIS/billing/DepositList";
import WithdrawDepositList from "../pages/HIS/billing/WithdrawDepositList";
import CreditReceipts from "../pages/HIS/billing/CreditReceipts";
import CreditPaid from "../pages/HIS/billing/CreditPaid";

export const BillingTabs = (t, navigate, hasPermission = () => true) => ({
  tabs: [
    {
      name: t("Cash"),
      children: [
        { name: t("CashInvoice"), content: <CashInvoices /> },
        { name: t("CreditNotesInvoice"), content: <CreditNotesInvoice /> },
      ],
    },
    {
      name: t("Insurance"),
      content: <InsuranceInvoice />,
    },
    {
      name: t("Corporate"),
      content: <CorporateInvoice />,
      // children: [
      //   { name: t("CorporateInvoice"), content: <CorporateInvoice /> },
      //   {
      //     name: t("CreditNotesCorporateInvoice"),
      //     content: <CreditNotesCorporateInvoice />,
      //   },
      // ],
    },
    {
      name: t("Government"),
      content: <GovernmentInvoice />,
      // children: [
      //   { name: t("GovernmentInvoice"), content: <GovernmentInvoice /> },
      //   {
      //     name: t("CreditNotesGovernmentInvoice"),
      //     content: <CreditNotesGovernmentInvoice />,
      //   },
      // ],
    },
    {
      name: t("Deposit"),
      children: [
        { name: t("Deposit"), content: <DepositList /> },
        { name: t("Withdraw Deposit"), content: <WithdrawDepositList /> },
      ],
    },
    {
      name: t("Credit"),
      children: [
        { name: t("Credit Receipts"), content: <CreditReceipts /> },
        { name: t("Credit Paid"), content: <CreditPaid /> },
      ],
    },
    {
      name: t("Insurance Claims"),
      children: [
        {
          name: (
            <div className="flex items-center gap-2 group">
              <span>{t("Insurance Claim Invoices")}</span>
              {hasPermission?.("billing", "create") && (
                <div
                  className="w-5 h-5 bg-[#0070C2] text-white rounded-md flex items-center justify-center hover:bg-[#005a9e] transition-colors shadow-sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate("/billing/insurance-claim-invoice/new");
                  }}
                  title={t("New Invoice")}
                >
                  <FaPlus size={10} />
                </div>
              )}
            </div>
          ),
          content: <InsuranceClaimInvoiceList />,
        },
        {
          name: (
            <div className="flex items-center gap-2 group">
              <span>{t("Credit Company Invoice")}</span>
              {hasPermission?.("billing", "create") && (
                <div
                  className="w-5 h-5 bg-[#0070C2] text-white rounded-md flex items-center justify-center hover:bg-[#005a9e] transition-colors shadow-sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    window.dispatchEvent(
                      new CustomEvent("openInsuranceClaimCreditInvoiceModal"),
                    );
                  }}
                  title={t("Create Credit Company Invoice")}
                >
                  <FaPlus size={10} />
                </div>
              )}
            </div>
          ),
          content: <InsuranceClaimCreditInvoice />,
        },
      ],
    },
  ],
  className: "custom-class",
});

const amountBody = (el) => {
  return el?.patient_share % 1 !== 0
    ? el.patient_share?.toFixed(2)
    : el?.patient_share;
};

export const InvoiceDateBody = (el) => {
  return formatDate(el.invoice_date);
};

export const taxBody = (el) => {
  return el?.patient_vat % 1 !== 0
    ? el.patient_vat?.toFixed(2)
    : el?.patient_vat;
};

const paidAmountBody = (el) => {
  return el?.patient_share % 1 !== 0
    ? (el.patient_share + el.patient_vat)?.toFixed(2)
    : el?.patient_share + el.patient_vat;
};

const createdByBody = (row) => {
  if (row?.created_by?.name) {
    return row.created_by.name;
  }

  if (row?.staff_info?.user?.fullname && row?.created_by) {
    return `${row.staff_info.user.fullname} (${row.created_by})`;
  }

  return row?.created_by || "-";
};

const patientStatusBidy = (el) => {
  let rowData = {
    status: el?.is_patient_cancelled ? "cancelled" : el?.patient_status,
  };
  return statusTemplate(rowData);
};

export const InvoiceColumns = (t, auth, setSelectedInvoices) => [
  {
    header: t("InvoiceNumber"),
    body: (row) => row?.cash_invoice_number || row?.invoice_number,
  },
  { header: t("Date"), body: InvoiceDateBody },
  { header: t("PatientName"), field: "patient.full_name" },
  { header: t("MRN"), field: "patient.file_no" },
  { header: t("Nationality"), field: "patient.nationality" },
  { header: t("Practitioner Name"), field: "visit.practitioner.name" },
  { header: t("PatientAmount"), body: amountBody },
  { header: t("PatientVat"), body: taxBody },
  { header: t("PatientPaidAmount"), body: paidAmountBody },
  {
    header: t("PaymentMethod"),
    body: (row) => {
      const isMultipayment = row?.payment_method === "multi_payment";
      const methods = row?.visit?.payment_detail
        ? row.visit.payment_detail
            .map((data) =>
              data?.amount > 0
                ? data?.payment_method
                : !isMultipayment
                  ? data?.payment_method
                  : false,
            )
            .filter(Boolean)
        : row?.payment_method
          ? [row.payment_method]
          : [];

      if (methods.length === 1) {
        return methods[0]; // Cash
      }

      return methods.length ? `[${methods.join(", ")}]` : "";
    },
  },
  { header: t("created_by"), field: "created_by" },
  { header: t("last_updated_by"), field: "last_updated_by" },
  {
    header: t("EpisodeType"),
    body: (rowData) => (
      <CustomChip
        label={rowData?.visit?.episode_type}
        className="h-[22px] rounded-full px-2 py-1"
        chipType={
          rowData?.visit?.episode_type === "First Visit"
            ? "secondary"
            : "warning"
        }
      />
    ),
  },
  // { header: t("Status"), body: patientStatusBidy },
  {
    header: t("Zatca Status"),
    field: "zatca_status",
    body: (rowData) => (
      <CustomChip
        label={rowData?.zatca_status || "Not Reported"}
        className="h-[22px] rounded-full px-2 py-1"
        chipType={
          rowData?.zatca_status === "REPORTED" ||
          rowData?.zatca_status === "CLEARED"
            ? "success"
            : rowData?.zatca_status === "FAILED"
              ? "danger"
              : "default"
        }
      />
    ),
  },
];

const companyAmountBody = (el) => {
  return el?.company_share % 1 !== 0
    ? el.company_share?.toFixed(2)
    : el?.company_share;
};

const companyVatBody = (el) => {
  return el?.company_vat % 1 !== 0
    ? el.company_vat?.toFixed(2)
    : el?.company_vat;
};

const companyPaidAmountBody = (el) => {
  return el.net_company_payable_amount % 1 !== 0
    ? el.net_company_payable_amount?.toFixed(2)
    : el?.net_company_payable_amount;
};

const companyStatusBody = (el) => {
  let rowData = {
    status: el?.is_company_cancelled ? "cancelled" : el?.company_status,
  };
  return statusTemplate(rowData);
};

export const InsuranceInvoiceColumns = (
  t,
  setSelectedInvoices,
  type = null,
) => [
  {
    header: t("InvoiceNumber"),
    body: (row) =>
      type === "corporate"
        ? row?.corporate_invoice_number || row?.invoice_number
        : type === "government"
          ? row?.government_invoice_number || row?.invoice_number
          : row?.insurance_invoice_number || row?.invoice_number,
  },
  { header: t("Date"), body: InvoiceDateBody },
  { header: t("PatientName"), field: "patient.full_name" },
  { header: t("MRN"), field: "patient.file_no" },
  { header: t("Nationality"), field: "patient.nationality" },
  { header: t("Practitioner Name"), field: "visit.practitioner.name" },
  { header: t("CompanyAmount"), body: companyAmountBody },
  { header: t("CompanyVat"), body: companyVatBody },
  { header: t("CompanyPaidAmount"), body: companyPaidAmountBody },
  {
    header: t("Episode Type"),
    body: (rowData) => (
      <CustomChip
        label={rowData?.visit?.episode_type}
        className="h-[22px] rounded-full px-2 py-1"
        chipType={
          rowData?.visit?.episode_type === "First Visit"
            ? "secondary"
            : "warning"
        }
      />
    ),
  },
  // { header: t("Status"), body: companyStatusBody },
];

export const InsuranceClaimInvoiceColumns = (t) => [
  { header: t("Inv. No"), field: "invoice_no" },
  { header: t("Date"), body: (row) => formatDate(row.date) },
  {
    header: t("Mon."),
    body: (row) =>
      moment()
        .month(row.month - 1)
        .format("MMMM"),
  },
  { header: t("Year"), field: "year" },
  {
    header: t("Payer"),
    body: (row) => (
      <span className="block whitespace-normal break-words leading-4">
        {row?.payer?.name_en || row?.payer_name || row?.payer?.name || "-"}
      </span>
    ),
    style: { width: "160px", maxWidth: "160px" },
    bodyCellClass: "!whitespace-normal",
  },
  {
    header: t("Gross"),
    body: (row) => Number(row?.total_gross || 0).toFixed(2),
  },
  {
    header: t("Disc."),
    body: (row) => Number(row?.total_discount || 0).toFixed(2),
  },
  {
    header: t("Net"),
    body: (row) => Number(row?.total_net || 0).toFixed(2),
  },
  // {
  //   header: t('Total GSA Amount'),
  //   body: row => Number(row?.total_gsa_amount || 0).toFixed(2)
  // },
  {
    header: t("Deductible"),
    body: (row) => Number(row?.total_deduction || 0).toFixed(2),
  },
  {
    header: t("Co. Share"),
    body: (row) => Number(row?.company_share || 0).toFixed(2),
  },
  { header: t("VAT"), body: (row) => Number(row?.total_vat || 0).toFixed(2) },
  {
    header: t("Co. Share + VAT"),
    body: (row) => Number(row?.company_share_with_vat || 0).toFixed(2),
    headerTitleClass: "!whitespace-normal !leading-tight text-center",
  },
  {
    header: t("ZATCA"),
    field: "zatca_status",
    body: (rowData) => (
      <CustomChip
        label={rowData?.zatca_status || "Not Reported"}
        className="h-[22px] rounded-full px-2 py-1"
        chipType={
          rowData?.zatca_status === "REPORTED" ||
          rowData?.zatca_status === "CLEARED"
            ? "success"
            : rowData?.zatca_status === "FAILED"
              ? "danger"
              : "default"
        }
      />
    ),
  },
];

const CancelStatus = (label) => {
  return (
    <CustomChip
      label={label}
      chipType={getColor(label)}
      className="h-[22px] rounded-full px-2 py-1"
    />
  );
};

export const CreditInvoiceColumns = (t, auth) => [
  {
    header: t("InvoiceNumber"),
    body: (row) => row?.credit_cash_invoice_number || row?.invoice_number,
  },
  { header: t("Date"), body: (row) => formatDateTime(row?.invoice_date) },
  { header: t("PatientName"), field: "patient.full_name" },
  { header: t("Nationality"), field: "patient.nationality" },
  { header: t("MRN"), field: "patient.file_no" },
  { header: t("Practitioner Name"), field: "visit.practitioner.name" },
  { header: t("PatientShare"), field: "patient_share" },
  { header: t("TotalVAT"), field: "patient_vat" },
  {
    header: t("Episode Type"),
    body: (rowData) => (
      <CustomChip
        label={rowData?.visit?.episode_type}
        className="h-[22px] rounded-full px-2 py-1"
        chipType={
          rowData?.visit?.episode_type === "First Visit"
            ? "secondary"
            : "warning"
        }
      />
    ),
  },
  // { header: t("Status"), body: (row) => CancelStatus(row?.patient_status) },
  ...(auth?.subscription?.zatca_check
    ? [
        {
          header: t("Zatca Status"),
          field: "transfer_status",
          body: (rowData) =>
            rowData?.zatca_status === "REPORTED" ||
            rowData?.zatca_status === "CLEARED" ? (
              <CustomChip
                label={rowData?.zatca_status}
                className="h-[22px] rounded-full px-2 py-1"
                chipType="success"
              />
            ) : (
              <CustomChip
                label="Not REPORTED"
                chipType="danger"
                className="h-[22px] rounded-full px-2 py-1"
              />
            ),
        },
      ]
    : []),
  { header: t("Returned By"), body: (row) => row?.returned_by },
  {
    header: t("Returned Reason"),
    body: (row) =>
      row?.patient_status == "Returned"
        ? row?.returned_reason
        : row?.cancelled_reason,
  },
  { header: t("Cancelled By"), body: (row) => row?.cancelled_by },
];

export const CreditInsuranceInvoiceColumns = (t) => [
  {
    header: t("InvoiceNumber"),
    body: (row) => row?.credit_insurance_invoice_number || row?.invoice_number,
  },
  { header: t("Date"), body: (row) => formatDateTime(row?.invoice_date) },
  { header: t("PatientName"), field: "patient.full_name" },
  { header: t("Nationality"), field: "nationality" },
  { header: t("MRN"), field: "patient.file_no" },
  { header: t("PatientShare"), field: "patient_share" },
  { header: t("CompanyPaidAmount"), field: "company_share" },
  {
    header: t("Episode Type"),
    body: (rowData) => (
      <CustomChip
        label={rowData?.visit?.episode_type}
        className="h-[22px] rounded-full px-2 py-1"
        chipType={
          rowData?.visit?.episode_type === "First Visit"
            ? "secondary"
            : "warning"
        }
      />
    ),
  },
  // { header: t("Status"), body: (row) => CancelStatus(row?.company_status) },
  { header: t("Cancelled By"), body: (row) => row?.last_updated_by },
  {
    header: t("Reason"),
    body: (row) =>
      row?.company_status == "Returned"
        ? row?.returned_reason
        : row?.cancelled_reason,
  },
];

const cashInvoicesTranslations = {
  en: {
    date: "Date",
    invoiceNumber: "Invoice Number",
    fileNumber: "MRN",
    patientName: "Patient Name",
    patientAmount: "Patient Amount",
    patientVat: "Patient VAT",
    patientPaidAmount: "Patient Paid Amount",
    nationality: "Nationality",
    status: "Status",
    transferStatus: "Transfer Status",
  },
  ar: {
    date: "تاريخ",
    invoiceNumber: "رقم الفاتورة",
    fileNumber: "رقم الملف",
    patientName: "اسم المريض",
    patientAmount: "مبلغ المريض",
    patientVat: "ضريبة المريض",
    patientPaidAmount: "المبلغ المدفوع من المريض",
    nationality: "الجنسية",
    status: "الحالة",
    transferStatus: "حالة التحويل",
  },
};

const companyInvoicesTranslations = {
  en: {
    date: "Date",
    invoiceNumber: "Invoice Number",
    fileNumber: "MRN",
    patientName: "Patient Name",
    companyAmount: "Company Amount",
    companyVat: "Company VAT",
    companyPaidAmount: "Company Paid Amount",
    nationality: "Nationality",
    status: "Status",
    transferStatus: "Transfer Status",
  },
  ar: {
    date: "تاريخ",
    invoiceNumber: "رقم الفاتورة",
    fileNumber: "رقم الملف",
    patientName: "اسم المريض",
    companyAmount: "مبلغ الشركة",
    companyVat: "ضريبة الشركة",
    companyPaidAmount: "المبلغ المدفوع من الشركة",
    nationality: "الجنسية",
    status: "الحالة",
    transferStatus: "حالة التحويل",
  },
};

export const exportCashInvoicesintoExcelColumns = (data, lang) => {
  const keys = cashInvoicesTranslations[lang] || cashInvoicesTranslations.en;
  const formatValue = (value) =>
    lang === "ar" ? Number(value) : String(value);

  return data?.map((item) => ({
    [keys.date]: moment(item?.date).format("YYYY-MM-DD HH:mm:ss"),
    [keys.invoiceNumber]: formatValue(item?.invoice_number),
    [keys.fileNumber]: formatValue(item?.patient?.file_no),
    [keys.patientName]: item?.patient?.full_name || item?.patientName || "",
    [keys.patientAmount]: formatValue(
      item?.patient_share % 1 !== 0
        ? item.patient_share?.toFixed(2)
        : item?.patient_share,
    ),
    [keys.patientVat]: formatValue(paidAmountBody(item)),
    [keys.patientPaidAmount]: formatValue(
      item?.patient_share + item?.patient_vat,
    ),
    [keys.nationality]: item?.nationality,
    [keys.status]: item?.patient_status,
    [keys.transferStatus]:
      item?.transfer_status === "Transferred"
        ? lang === "ar"
          ? "تم التحويل"
          : "Transferred"
        : lang === "ar"
          ? "لم يتم التحويل"
          : "Not Transferred",
  }));
};

export const exportCompanyInvoicesToExcelColumns = (data, lang) => {
  const keys =
    companyInvoicesTranslations[lang] || companyInvoicesTranslations.en;
  const formatValue = (value) =>
    lang === "ar" ? Number(value) : String(value);

  return data?.map((item) => ({
    [keys.date]: moment(item?.date).format("YYYY-MM-DD HH:mm:ss"),
    [keys.invoiceNumber]: formatValue(item?.invoice_number),
    [keys.fileNumber]: formatValue(item?.patient?.file_no),
    [keys.patientName]: item?.patient?.full_name || "",
    [keys.companyAmount]: formatValue(companyAmountBody(item)),
    [keys.companyVat]: formatValue(companyVatBody(item)),
    [keys.companyPaidAmount]: formatValue(companyPaidAmountBody(item)),
    [keys.nationality]: item?.nationality,
    [keys.status]: companyStatusBody(item),
  }));
};

export const creditInvoicesTranslations = {
  en: {
    invoiceNumber: "Invoice Number",
    date: "Date",
    patientName: "Patient Name",
    patientShare: "Patient Share",
    totalVAT: "Total VAT",
    fileNumber: "MRN",
    status: "Status",
    nationality: "Nationality",
  },
  ar: {
    invoiceNumber: "رقم الفاتورة",
    date: "تاريخ",
    patientName: "اسم المريض",
    patientShare: "مشاركة المريض",
    totalVAT: "إجمالي ضريبة القيمة المضافة",
    fileNumber: "رقم الملف",
    status: "الحالة",
    nationality: "الجنسية",
  },
};

export const exportCreditInvoicesToExcelColumns = (data, lang) => {
  const keys =
    creditInvoicesTranslations[lang] || creditInvoicesTranslations.en;
  const formatValue = (value) =>
    lang === "ar" ? Number(value) : String(value);
  return data?.map((item) => ({
    [keys.invoiceNumber]: formatValue(item?.invoice_number),
    [keys.date]: moment(item?.invoice_date).format("YYYY-MM-DD HH:mm:ss"),
    [keys.patientName]: item?.patient?.full_name || "",
    [keys.fileNumber]: formatValue(item?.patient?.file_no),
    [keys.patientShare]: formatValue(item?.patient_share),
    [keys.totalVAT]: formatValue(item?.patient_vat),
    [keys.status]: item?.patient_status || "",
    [keys.nationality]: item?.nationality || "",
  }));
};

export const creditInsuranceInvoicesTranslations = {
  en: {
    invoiceNumber: "Invoice Number",
    date: "Date",
    patientName: "Patient Name",
    patientShare: "Patient Share",
    companyPaidAmount: "Company Paid Amount",
    fileNumber: "MRN",
    nationality: "Nationality",
    status: "Status",
  },
  ar: {
    invoiceNumber: "رقم الفاتورة",
    date: "تاريخ",
    patientName: "اسم المريض",
    patientShare: "مشاركة المريض",
    companyPaidAmount: "المبلغ المدفوع من الشركة",
    fileNumber: "رقم الملف",
    nationality: "الجنسية",
    status: "الحالة",
  },
};

export const exportCreditInsuranceInvoicesToExcelColumns = (data, lang) => {
  const keys =
    creditInsuranceInvoicesTranslations[lang] ||
    creditInsuranceInvoicesTranslations.en;
  const formatValue = (value) =>
    lang === "ar" ? Number(value) : String(value);

  return data?.map((item) => ({
    [keys.invoiceNumber]: formatValue(item?.invoice_number),
    [keys.date]: moment(item?.invoice_date).format("YYYY-MM-DD HH:mm:ss"),
    [keys.patientName]: item?.patient?.full_name || "",
    [keys.fileNumber]: formatValue(item?.patient?.file_no),
    [keys.patientShare]: formatValue(item?.patient_share),
    [keys.companyPaidAmount]: formatValue(item?.company_share),
    [keys.nationality]: item?.nationality || "",
    [keys.status]: item?.company_status || "",
  }));
};

export const SummaryData = (data, t) => {
  return [
    {
      label: t("Total Amount Without Tax"),
      value: data?.total_amount_without_tax ?? "--",
      color: "bg-yellow-100",
      icon: <FaFileInvoiceDollar className="text-yellow-600" />,
    },
    {
      label: t("Total Tax Amount"),
      value: data?.total_tax_amount ?? "--",
      color: "bg-red-100",
      icon: <FaPercentage className="text-red-600" />,
    },

    {
      label: t("Total Amount With Tax"),
      value: data?.total_amount_with_tax ?? data?.total_amount_with ?? "--",
      color: "bg-green-100",
      icon: <FaMoneyBillWave className="text-green-600" />,
    },
    {
      label: t("Total Records"),
      value: data?.totalRecords ?? "--",
      color: "bg-gray-100",
      icon: <FaClipboardList className="text-blue-600" />,
    },
  ];
};
export const editBillingColumns = (t) => [
  { name: "Item Code", key: "item_code", colType: "field", type: "text" },
  { name: "Item Type", key: "item_type", colType: "field", type: "text" },
  {
    name: "Item Name (EN)",
    key: "item_name_en",
    colType: "field",
    type: "text",
  },
  {
    name: "Item Name (AR)",
    key: "item_name_ar",
    colType: "field",
    type: "text",
  },
  {
    name: "Unit Price",
    key: "unit_price",
    colType: "field",
    type: "number",
    disabled: true,
  },
  {
    name: "Quantity",
    key: "quantity",
    colType: "field",
    type: "number",
    disabled: true,
  },
  {
    name: "Gross Amount",
    key: "gross_amount",
    colType: "field",
    type: "number",
    disabled: true,
  },
  {
    name: "Discount Type",
    key: "discount_type",
    colType: "dropdown",
    options: [
      { label: "Percentage", value: "percentage" },
      { label: "Fixed", value: "fixed" },
    ],
    type: "text",
    disabled: true,
  },
  {
    name: "Discount Value",
    key: "discount_value",
    colType: "field",
    type: "number",
    disabled: true,
  },
  {
    name: "Discount Amount",
    key: "discount_amount",
    colType: "field",
    type: "number",
    disabled: true,
  },
  {
    name: "Net Payable",
    key: "net_payable_amount",
    colType: "field",
    type: "number",
    disabled: true,
  },
  {
    name: "Patient Share",
    key: "patient_share",
    colType: "field",
    type: "number",
    disabled: true,
  },
  {
    name: "Company Share",
    key: "company_share",
    colType: "field",
    type: "number",
    disabled: true,
  },
  {
    name: "Patient Tax Check",
    key: "patient_tax_check",
    colType: "switch",
    disabled: true,
  },
  {
    name: "Patient Tax Type",
    key: "patient_tax_type",
    colType: "dropdown",

    options: [
      { label: "Percentage", value: "percentage" },
      { label: "Fixed", value: "fixed" },
    ],
    type: "text",
    disabled: true,
  },
  {
    name: "Patient Tax Amount",
    key: "patient_tax_amount",
    colType: "field",
    type: "number",
    disabled: true,
  },
  {
    name: "Company Tax Check",
    key: "company_tax_check",
    colType: "switch",
    disabled: true,
  },
  {
    name: "Company Tax Type",
    key: "company_tax_type",
    colType: "dropdown",
    options: [
      { label: "Percentage", value: "percentage" },
      { label: "Fixed", value: "fixed" },
    ],
    type: "text",
    disabled: true,
  },
  {
    name: "Company Tax Amount",
    key: "company_tax_amount",
    colType: "field",
    type: "number",
    disabled: true,
  },
  {
    name: "Patient Share (VAT)",
    key: "patient_share_with_vat",
    colType: "field",
    type: "number",
    disabled: true,
  },
  {
    name: "Company Share (VAT)",
    key: "company_share_with_vat",
    colType: "field",
    type: "number",
    disabled: true,
  },
  {
    name: "Total Amount",
    key: "total_amount",
    colType: "field",
    type: "number",
    disabled: true,
  },
  {
    name: "Status",
    key: "status",
    colType: "dropdown",
    type: "text",
    options: [
      { label: "Paid", value: "Paid" },
      { label: "Un Paid", value: "Unpaid" },
    ],
    disabled: true,
  },
];

export const DepositColumns = (t) => [
  {
    header: t("Deposit Date"),
    body: (row) => {
      return formatDateTime(row?.deposit_detail?.deposit_date);
    },
  },
  {
    header: t("InvoiceNumber"),
    body: (row) => {
      return row?.deposit_invoice_number || row?.invoice_number;
    },
  },
  {
    header: t("Patient Name"),
    body: (row) => {
      return row?.patient_name;
    },
  },
  {
    header: t("MRN"),
    field: "file_number",
  },
  {
    header: t("Document ID"),
    field: "document_id",
  },
  {
    header: t("Patient Contact"),
    field: "patient_contact",
  },
  {
    header: t("Amount"),
    body: (row) => {
      return row?.deposit_amount;
    },
  },
  {
    header: t("PaymentMethod"),
    body: (row) => {
      const isMultipayment =
        row?.deposit_detail?.payment_option === "multi_payment";
      const methods = row?.deposit_detail?.payment_detail
        ? row?.deposit_detail?.payment_detail
            ?.map((data) =>
              data?.amount > 0
                ? data?.payment_method
                : !isMultipayment
                  ? data?.payment_method
                  : false,
            )
            ?.filter(Boolean)
        : "--"
          ? [row.payment_method]
          : [];

      if (methods.length === 1) {
        return methods[0]; // Cash
      }

      return methods.length ? `[${methods.join(", ")}]` : "";
    },
  },
  { header: t("created_by"), body: createdByBody },
  {
    header: t("Zatca Status"),
    field: "zatca_status",
    body: (rowData) => (
      <CustomChip
        label={rowData?.zatca_status || "Not Reported"}
        className="h-[22px] rounded-full px-2 py-1"
        chipType={
          rowData?.zatca_status === "REPORTED" ||
          rowData?.zatca_status === "CLEARED"
            ? "success"
            : rowData?.zatca_status === "FAILED"
              ? "danger"
              : "default"
        }
      />
    ),
  },
];

export const WithdrawDepositColumns = (t) => [
  {
    header: t("Withdraw Date"),
    body: (row) => {
      return formatDateTime(row?.withdraw_detail?.withdraw_date);
    },
  },
  {
    header: t("InvoiceNumber"),
    body: (row) => {
      return row?.withdraw_invoice_number || row?.invoice_number;
    },
  },
  {
    header: t("Patient Name"),
    body: (row) => {
      return row?.patient_name;
    },
  },
  {
    header: t("MRN"),
    field: "file_number",
  },
  {
    header: t("Document ID"),
    field: "document_id",
  },
  {
    header: t("Patient Contact"),
    field: "patient_contact",
  },
  {
    header: t("Withdraw Amount"),
    body: (row) => {
      return row?.withdraw_amount;
    },
  },
  {
    header: t("Available Balance"),
    body: (row) => {
      return row?.new_balance;
    },
  },
  {
    header: t("PaymentMethod"),
    body: (row) => {
      const isMultipayment =
        row?.withdraw_detail?.payment_option === "multi_payment";
      const methods = row?.withdraw_detail?.payment_detail
        ? row?.withdraw_detail?.payment_detail
            ?.map((data) =>
              data?.amount > 0
                ? data?.payment_method
                : !isMultipayment
                  ? data?.payment_method
                  : false,
            )
            ?.filter(Boolean)
        : "--"
          ? [row.payment_method]
          : [];

      if (methods.length === 1) {
        return methods[0]; // Cash
      }

      return methods.length ? `[${methods.join(", ")}]` : "";
    },
  },
  { header: t("created_by"), body: createdByBody },
];

export const ClaimListColumns = (t, showType = "default") => [
  {
    header: t("No"),
    body: sequenceTableTemplate,
  },
  ...(showType === "ready"
    ? [
        {
          header: t("Prepared At"),
          body: (row) =>
            row?.claim?.prepared_at
              ? formatDateTime(row.claim.prepared_at)
              : "-",
        },
      ]
    : []),
  ...(showType === "submitted"
    ? [
        {
          header: t("Submitted Date"),
          body: (row) =>
            row?.claim?.submitted_at
              ? formatDateTime(row.claim.submitted_at)
              : "-",
        },
      ]
    : []),
  {
    header: t("Patient Name"),
    field: "patient_info.full_name",
  },
  {
    header: t("MRN"),
    field: "patient_info.file_no",
  },
  {
    header: t("Document ID"),
    field: "patient_info.document_id",
  },
  {
    header: t("Contact"),
    field: "patient_info.contact",
  },
  {
    header: t("Practitioner"),
    field: "practitioner_info.name",
  },
  {
    header: t("Diagnoses"),
    field: "rcm_request.diagnosis",
    body: (row) => {
      const diagnoses = row?.claim?.rcm_request?.diagnosis;
      return (
        <div>
          {diagnoses && diagnoses.length > 0
            ? diagnoses.map((item) => item?.code).join(", ")
            : "-"}
        </div>
      );
    },
    bodyCellClass: "!whitespace-pre-wrap",
  },
  {
    header: t("Priority"),
    field: "claim.rcm_request.priority",
    bodyCellClass: "!whitespace-pre-wrap",
  },
  {
    header: t("Claim Type"),
    field: "claim.claim_type",
    bodyCellClass: "!whitespace-pre-wrap",
  },
  {
    header: t("Status"),
    field: "claim.status",
    bodyCellClass: "!whitespace-pre-wrap",
    body: (row) => (
      <CustomChip
        label={row?.claim?.status}
        chipType={
          row?.claim?.status === "pending"
            ? "warning"
            : row?.claim?.status === "submitted"
              ? "success"
              : row?.claim?.status === "failed"
                ? "danger"
                : "default"
        }
        className="h-[22px]"
      />
    ),
  },
  ...(showType === "submitted"
    ? [
        {
          header: t("Attempts"),
          body: (row) => (
            <span className="flex items-center justify-center">
              {row?.claim?.submit_attempt_count
                ? row.claim.submit_attempt_count
                : "1"}
            </span>
          ),
        },
      ]
    : []),
];

export const depositHistoryColumns = (t) => [
  {
    header: t("Date"),
    body: (row) => {
      return formatDateTime(row?.created_at);
    },
  },
  {
    header: t("InvoiceNumber"),
    body: (row) => {
      return row?.deposit_invoice_number || row?.invoice_number || "--";
    },
  },
  {
    header: t("Status"),
    body: (row) => {
      const isWithdraw =
        row?.status === "Withdraw" || row?.status === "withdraw";
      const isDeposit = row?.status === "Deposit" || row?.status === "deposit";
      const isSpended = row?.status == "Spended" || row?.status == "spended";
      return (
        <CustomChip
          label={
            isWithdraw
              ? t("Withdraw")
              : isDeposit
                ? t("Deposit")
                : isSpended
                  ? t("Spended")
                  : row?.status
          }
          chipType={
            isWithdraw
              ? "danger"
              : isDeposit
                ? "success"
                : isSpended
                  ? "warning"
                  : "default"
          }
          className="h-[22px] rounded-full px-2 py-1"
        />
      );
    },
  },
  {
    header: t("Patient Name"),
    body: (row) => {
      return row?.patient_name || row?.patient?.full_name || "-";
    },
  },
  {
    header: t("MRN"),
    field: "file_number",
  },
  {
    header: t("Amount"),
    body: (row) => {
      const isWithdraw =
        row?.status === "Withdraw" || row?.status === "withdraw";
      const isDeposit = row?.status === "Deposit" || row?.status === "deposit";
      const isSpended = row?.status == "Spended" || row?.status == "spended";

      const amount =
        isWithdraw || isSpended
          ? row?.withdraw_detail?.withdraw_amount
          : row?.deposit_detail?.deposit_amount;
      return (
        <span
          className={`font-semibold ${
            isWithdraw ? "text-red-600" : isDeposit ? "text-green-600" : ""
          }`}
        >
          {isWithdraw ? "-" : isDeposit ? "+" : ""}{" "}
          {Number(amount || 0)?.toFixed(2)} SAR
        </span>
      );
    },
  },
  {
    header: t("Updated Balance"),
    body: (row) => {
      const isWithdraw =
        row?.status === "Withdraw" || row?.status === "withdraw";
      const isSpended = row?.status == "Spended" || row?.status == "spended";
      return (
        <span className={`font-semibold`}>
          {Number(
            isWithdraw || isSpended
              ? row?.withdraw_detail?.remaining_amount
              : row?.deposit_detail?.total_amount || 0,
          )?.toFixed(2)}{" "}
          SAR
        </span>
      );
    },
  },
  {
    header: t("Performed By"),
    body: (row) => row?.action_performed_by?.name || "-",
  },
  {
    header: t("Action Reason"),
    body: (row) => row?.action_reason || "-",
  },
];

export const CreditReceiptColumns = (t, paid = false) => [
  {
    header: t("Date"),
    body: (row) => formatDateTime(row?.created_at),
  },
  {
    header: t("Receipt Number"),
    field: "receipt_number",
  },
  {
    header: t("Department"),
    field: "department_name",
  },
  {
    header: t("Patient Name"),
    field: "patient_name",
  },
  {
    header: t("MRN"),
    field: "patient_file_no",
  },
  {
    header: t("Document ID"),
    field: "patient_document_id",
  },
  {
    header: t("Amount"),
    body: (row) =>
      paid
        ? Number(
            row?.patient_pay_credit?.patient_pay_credit_amount || 0,
          )?.toFixed(2)
        : Number(row?.patient_credit?.patient_credit_amount || 0)?.toFixed(2),
  },
];

export const creditHistoryColumns = (t) => [
  {
    header: t("Date"),
    body: (row) => formatDateTime(row?.created_at),
  },
  {
    header: t("Receipt Number"),
    field: "receipt_number",
  },
  {
    header: t("Transaction Type"),
    body: (row) => {
      const type = row?.transaction_type;
      const displayType = type === "PayCredit" ? "Pay Credit" : type;
      return (
        <CustomChip
          label={displayType || "-"}
          chipType={
            type === "Credit"
              ? "success"
              : type === "PayCredit"
                ? "warning"
                : "default"
          }
          className="h-[22px] rounded-full px-2 py-1"
        />
      );
    },
  },
  {
    header: t("Department"),
    field: "department_name",
  },
  {
    header: t("MRN"),
    field: "patient_file_no",
  },
  {
    header: t("Document ID"),
    field: "patient_document_id",
  },
  {
    header: t("Amount"),
    body: (row) => {
      const isCredit = row?.transaction_type === "Credit";
      const isPayCredit = row?.transaction_type === "PayCredit";

      const creditAmount = row?.credit_history_details?.credit_amount;
      const payAmount = row?.pay_credit_history_details?.pay_credit_amount;

      if (isCredit && creditAmount > 0) {
        return (
          <span className="font-semibold text-green-600">
            {Number(creditAmount)?.toFixed(2)} SAR
          </span>
        );
      } else if (isPayCredit && payAmount > 0) {
        return (
          <span className="font-semibold text-orange-600">
            {Number(payAmount)?.toFixed(2)} SAR
          </span>
        );
      }
      return "-";
    },
  },
  // {
  //   header: t("Balance"),
  //   body: (row) => {
  //     const isCredit = row?.transaction_type === "Credit";
  //     const isPayCredit = row?.transaction_type === "PayCredit";

  //     const creditTotal = row?.credit_history_details?.total_credit_amount;
  //     const payTotal = row?.pay_credit_history_details?.total_pay_credit_amount;

  //     const balance = isCredit ? creditTotal : isPayCredit ? payTotal : null;

  //     return balance !== null && balance !== undefined ? (
  //       <span className="font-semibold text-blue-600">
  //         {Number(balance)?.toFixed(2)} SAR
  //       </span>
  //     ) : "-";
  //   },
  // },
  // {
  //   header: t("Payment Method"),
  //   body: (row) => {
  //     const paymentDetails = row?.pay_credit_history_details?.payment_detail;

  //     if (!paymentDetails || !Array.isArray(paymentDetails) || paymentDetails.length === 0) {
  //       return "-";
  //     }

  //     if (paymentDetails.length === 1) {
  //       return paymentDetails[0]?.payment_method || "-";
  //     }

  //     const methods = paymentDetails
  //       .filter(detail => detail?.payment_method && detail?.amount > 0)
  //       .map(detail => detail.payment_method);

  //     return methods.length > 0 ? `[${methods.join(", ")}]` : "-";
  //   },
  // },
  {
    header: t("Performed By"),
    body: (row) => row?.action_performed_by?.name || "-",
  },
  {
    header: t("Remarks"),
    body: (row) => row?.remarks || "-",
  },
];
